// extracted by mini-css-extract-plugin
module.exports = {"stellarus":"index-stellarus-1r7_r","btnDetail":"index-btnDetail-1E2Pi","mecha":"index-mecha-QpA6r","active":"index-active-2lnSp"};